import { IPayment } from 'types/app/reservations';

export const calculatePaymentAmount = (payment: IPayment) => {
  if (!payment) return null;
  const { amount, currency } = payment;
  return `${(amount / 100).toFixed(2)} ${currency}`;
};
